import React from 'react';
import {Text} from '../elements';

export function DropDownButton({ChevronDownIcon, name, open}) {
  return (
    // filter drop down button
    <>
      <Text as="span" color="dark" size="copy"weight='default'>
        {name}
      </Text>
      <span className="ml-6 flex items-center">
        {open ? (
          <ChevronDownIcon className="h-5 w-5 rotate-180" aria-hidden="true"/>
        ) : (
          <ChevronDownIcon className="h-5 w-5" aria-hidden="true"/>
        )}
      </span>
    </>
  );
}
